// extracted by mini-css-extract-plugin
export var canBeSelected = "tag-module--can-be-selected--uVihu";
export var container = "tag-module--container--mWGLu";
export var notActive = "tag-module--not-active--hIas6";